import React from "react";
import { USER_ROLES } from "../../../../../constants";
import FloatBatchActionsMenu from "../../../../../components/DataTable/FloatBatchActionsMenu";
import { StyledTable, StyledTouchableText } from "./styles";
import { usePreOrdersTable, columnLabel } from "./usePreOrdersTable";

const OrdersTable = ({
  userData,
  data,
  loading,
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onChangeItemsPerPage,
  multiselect,
  radiobutton,
  onCancelSelectedData,
  checkboxesControl,
  canCancel,
  ...props
}) => {
  const {
    toggleRowExpansion,
    renderProductsList,
    columnConfig,
    components,
    toggleConfig,
    rowWrapper,
    isAgent,
    isEmployee,
  } = usePreOrdersTable({
    data,
    multiselect,
    radiobutton,
    userData,
    checkboxesControl,
    canCancel,
    onCancelSelectedData,
  });
  return (
    <StyledTable
      name="pre-orders-table"
      isLoading={loading}
      footerText="Pré-pedidos por página:"
      data={data}
      handleHeaderTitle={(key) => columnLabel[key]}
      columnConfig={columnConfig}
      components={components}
      toggleConfig={toggleConfig}
      multiselect={isAgent || isEmployee ? null : multiselect}
      radiobutton={isAgent || isEmployee ? null : radiobutton}
      checkboxesControl={isAgent || isEmployee ? null : checkboxesControl}
      rowWrapper={rowWrapper}
      paginationProps={{
        currentPage,
        totalItems,
        itemsPerPage,
        onPageChange,
      }}
      renderToggleComponent={(toggle, rowIndex) => {
        const rowData = Array.isArray(data) ? data[rowIndex] : null;
        if (!rowData) return null;

        return renderProductsList(rowData);
      }}
      onChangeItemsPerPage={onChangeItemsPerPage}
      onRowClick={(data, rowIndex) => {
        toggleRowExpansion(rowIndex);
      }}
      showRightArrow={false}
      renderOutside={(selectedRows, setSelected) => (
        <FloatBatchActionsMenu
          show={!!selectedRows.length}
          selectedLabel={
            selectedRows.length > 1
              ? "pré-pedidos selecionados"
              : "pré-pedido selecionado"
          }
          selectedItems={selectedRows}
          onClose={() => {
            setSelected([]);
          }}
        >
          {!canCancel ? (
            <StyledTouchableText
              onClick={() => {
                onCancelSelectedData(selectedRows);
                setSelected([]);
              }}
            >
              {selectedRows.length === 1
                ? "Cancelar pré-pedido"
                : "Cancelar pré-pedidos"}
            </StyledTouchableText>
          ) : null}
          {/* <StyledTouchableText
            onClick={() => {
            onExportSelectedData(selectedRows);
             setSelected([]);
            }}
          >
            Exportar pedidos
          </StyledTouchableText> */}
        </FloatBatchActionsMenu>
      )}
      renderEmptyState={() => (
        <div style={{ textAlign: "center", padding: "20px" }}>
          Nenhum pré-pedido encontrado
        </div>
      )}
      {...props}
    />
  );
};

export default OrdersTable;
